webpackJsonp([38],{

/***/ 62:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"breadcrumb-item":"_3lyK8OooH9BWh1wHXAdwTL","breadcrumb-last-item":"_2rO8V_yo7fat1Rv3nlfC3Z","separator":"_1Z2WQR0IcvSWaAgxtmgljU","breadcrumb":"_17ZA2aQYdxXc7mteT2QDuM _13UyNN6lRQaIE4nGDzE2-d","breadcrumb-hidden":"_1W4CorlN8AMJGoX4oKVBqr"};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Breadcrumbs = __webpack_require__(62);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _config = __webpack_require__(37);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Breadcrumbs: {
	    displayName: 'Breadcrumbs'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Breadcrumbs/Breadcrumbs.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Breadcrumbs = _wrapComponent('Breadcrumbs')((_dec = (0, _reactCssModules2.default)(_Breadcrumbs2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Breadcrumbs, _Component);
	
	  function Breadcrumbs() {
	    (0, _classCallCheck3.default)(this, Breadcrumbs);
	    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumbs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Breadcrumbs, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          trip = _props.trip,
	          localExpert = _props.localExpert,
	          inspiration = _props.inspiration,
	          customStyle = _props.customStyle;
	
	      var separator = function separator(key) {
	        return _react3.default.createElement('i', { className: 'fa fa-angle-right', styleName: 'separator', key: 'separator-' + key });
	      };
	      return _react3.default.createElement(
	        'span',
	        { styleName: 'breadcrumb', style: customStyle, itemScope: true, itemType: 'http://schema.org/BreadcrumbList' },
	        _react3.default.createElement(
	          'span',
	          { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem' },
	          _react3.default.createElement(
	            'a',
	            { itemProp: 'item', href: '/' },
	            _react3.default.createElement(
	              'span',
	              { styleName: 'breadcrumb-item', itemProp: 'name' },
	              'Home'
	            ),
	            _react3.default.createElement('meta', { itemProp: 'position', content: '1' })
	          )
	        ),
	        function () {
	          switch (type) {
	            case 'TripDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/to/' + encodeURIComponent(trip.destination_location) },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    trip.destination_location
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  trip.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' })
	              )];
	            case 'LocalExpertProfile':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  localExpert.name.first + ' ' + localExpert.name.last
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Inspirations':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Inspiration'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration '
	                })
	              )];
	            case 'InspirationDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/inspiration' },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    'Inspiration'
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  inspiration.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration/' + inspiration.slug
	                })
	              )];
	            case 'Career':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Career'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/career'
	                })
	              )];
	            case 'TrustAndSafety':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Trust & Safety'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/trust-and-safety'
	                })
	              )];
	            case 'Dtac':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Dtac'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Digi':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Digi'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/digi'
	                })
	              )];
	            case 'LocalExpertBenefits':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Local Expert Benefits'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/local-expert-benefits'
	                })
	              )];
	            case 'Sitemap':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Sitemap'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/sitemap'
	                })
	              )];
	            default:
	              return null;
	          }
	        }()
	      );
	    }
	  }]);
	  return Breadcrumbs;
	}(_react2.Component), _class2.propTypes = {
	  type: _react2.PropTypes.string.isRequired,
	  trip: _react2.PropTypes.object,
	  localExpert: _react2.PropTypes.object,
	  inspiration: _react2.PropTypes.object,
	  customStyle: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Breadcrumbs;
	module.exports = exports['default'];

/***/ }),

/***/ 1266:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_2k1_ZgJPoHn_izBUL2Gh_o _1sIUL8Csti_qoesv1eSx1i","inner":"UyqwLPgDRrKdv4316waah _41i8Pp6PmcXzDbgWssrnp","inspiration-banner":"_3FtMf1VwGgvXR51YHbvr35","banner-shadow":"Ear2sUoZ3G6ZeKK2eFkhb","header":"_2oNWxS-msYfMyX6UaHrTFS UiOtkwjAwJvCk7RAufbT2","inspirations-container":"_3UModCPCfQYQtIh2-XKqss","inspiration-card":"_1U1sS8iKNptjwilz6gM5dl","card-image":"_2tYTbzvrJyT8vpWHUD7yKi","card-image-img":"_2JR0FwRr2UMmp_NxzQ28_k","card-detail":"_20JezQB08dxtSlncy2JFIh _13UyNN6lRQaIE4nGDzE2-d","inspiration-name":"_1HHLXWRL26QcLKiIxNr5Ip","inspiration-description":"_2Vu1BtX1mFY9-rc6KthYZx","see-more-container":"_6Hab1O5cN5WjNk_PskTvn _13UyNN6lRQaIE4nGDzE2-d","card-shadow":"_29eMvmWei9D393FvqBz84z Ear2sUoZ3G6ZeKK2eFkhb _3jblqlydyeJqpKzpSv89pq"};

/***/ }),

/***/ 1431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5061ddaaf90fdf1e76070da69047d325.jpg";

/***/ }),

/***/ 1675:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Inspirations = __webpack_require__(1266);
	
	var _Inspirations2 = _interopRequireDefault(_Inspirations);
	
	var _reactIntl = __webpack_require__(10);
	
	var _Breadcrumbs = __webpack_require__(63);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _media = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxAsyncConnect = __webpack_require__(34);
	
	var _inspirations = __webpack_require__(265);
	
	var InspirationsAction = _interopRequireWildcard(_inspirations);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Inspirations: {
	    displayName: 'Inspirations'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/Inspirations/Inspirations.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	// import InspirationCard from 'components/Inspirations/InspirationCard';
	
	
	var Inspirations = _wrapComponent('Inspirations')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState;
	
	    if (!(0, _inspirations.isLoaded)(getState())) {
	      return dispatch((0, _inspirations.load)());
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    inspirations: state.inspirations.data,
	    error: state.inspirations.error,
	    loading: state.inspirations.loading
	  };
	}, InspirationsAction), _dec3 = (0, _reactCssModules2.default)(_Inspirations2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Inspirations, _Component);
	
	  function Inspirations() {
	    (0, _classCallCheck3.default)(this, Inspirations);
	    return (0, _possibleConstructorReturn3.default)(this, (Inspirations.__proto__ || (0, _getPrototypeOf2.default)(Inspirations)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Inspirations, [{
	    key: 'render',
	    value: function render() {
	      var bannerImage = __webpack_require__(1431);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(_reactHelmet2.default, {
	          meta: [{ 'property': 'og:image', 'content': 'https://www.takemetour.com' + bannerImage }]
	        }),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inspiration-banner' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'banner-shadow' },
	            _react3.default.createElement(
	              'h1',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.banner.header' })
	            ),
	            _react3.default.createElement(
	              'h3',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.banner.sub_header' })
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inner' },
	          _react3.default.createElement(_Breadcrumbs2.default, { type: 'Inspirations', customStyle: { paddingTop: '0px', paddingLeft: '10px' } }),
	          _react3.default.createElement(
	            'h2',
	            { styleName: 'header' },
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.content.header' })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'inspirations-container' },
	            this.props.inspirations.map(function (insp) {
	              if (insp.is_public) {
	                return _react3.default.createElement(
	                  _Link2.default,
	                  { key: insp._id, styleName: 'inspiration-card', to: '/inspiration/' + insp.slug },
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'card-image' },
	                    _react3.default.createElement('img', { src: (0, _media.path)(insp.thumbnail_image, 'coverTripCard'), styleName: 'card-image-img', alt: insp.name }),
	                    _react3.default.createElement(
	                      'div',
	                      { styleName: 'card-shadow' },
	                      _react3.default.createElement(
	                        'h2',
	                        null,
	                        insp.name
	                      )
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'card-detail' },
	                    _react3.default.createElement(
	                      'h3',
	                      { styleName: 'inspiration-name' },
	                      insp.name
	                    ),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'inspiration-description' },
	                      insp.description
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'see-more-container' },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.content.item.see_more' })
	                  )
	                );
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return Inspirations;
	}(_react2.Component), _class2.propTypes = {
	  inspirations: _react2.PropTypes.array,
	  error: _react2.PropTypes.string,
	  loading: _react2.PropTypes.bool,
	  load: _react2.PropTypes.func.isRequired
	}, _temp)) || _class) || _class) || _class));
	
	exports.default = Inspirations;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// inspirations-8fbb2c62936ce707efee.js